// removed by extract-text-webpack-plugin
module.exports = {"loader-container":"loader---loader-container---3z9L3","loaderContainer":"loader---loader-container---3z9L3","loader":"loader---loader---3Kv7h","spinner":"loader---spinner---2cR6i","small":"loader---small---lG1lQ","medium":"loader---medium---3uYbD","large":"loader---large----MUQK","loader-overlay":"loader---loader-overlay---IQP-L","loaderOverlay":"loader---loader-overlay---IQP-L"};


//////////////////
// WEBPACK FOOTER
// ./src/index.styl
// module id = 2
// module chunks = 0